import { render, staticRenderFns } from "./MainPageNewCopy.vue?vue&type=template&id=1ed89fc2&scoped=true&"
import script from "./MainPageNewCopy.vue?vue&type=script&lang=js&"
export * from "./MainPageNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./MainPageNewCopy.vue?vue&type=style&index=0&id=1ed89fc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed89fc2",
  null
  
)

export default component.exports